import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import ParserImage from "./ParserImage";
import SpinnerLoading from '../sampanganimation/SpinnerLoading';
import axios from "axios";
import Swal from "sweetalert2";
import useToken from "./useToken";
import Guest from "./middleware/Guest";
import { Toast } from 'primereact/toast';

import "./assets/themify-icon/themify-icons.css";
import "./assets/simple-line-icon/simple-line-icons.css";
import "./assets/font-awesome/css/all.css";
import "./assets/elagent/style.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./assets/animate.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/main.css";
import "./assets/responsive.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "./assets/custom.css";
import "primereact/resources/themes/lara-light-cyan/theme.css"

const LoginPage = (props) => {
    const [login, setLogin] = useState("");
    const [hide, setHide] = useState(true);
    const [passtype, setPasstype] = useState('password');
    const toast = useRef(null);

    const navigate = useNavigate();

    const { token, setToken } = useToken();

    const [formData, setFormData] = useState({
        username: '',
        password: '',
    });

    useEffect(() => {
        props.hideloader();
        ParserImage();
    });

    function showPassord() {
        if (hide) {
            setHide(false)
            setPasstype('text')
        } else {
            setHide(true)
            setPasstype('password')
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        SpinnerLoading(true);

        axios
            .post(global.config.backend + "/api/login", formData)
            .then((res) => {

                SpinnerLoading(false);

                if (res.data.status) {
                    setToken(res.data.data);
                    navigate(-1);
                }

                if (!res.data.status) {

                    if (res.data.errors.length > 0) {
                        res.data.errors.map((item) => {
                            toast.current.show({ severity: 'warn', detail: item });
                        });
                    } else {
                        toast.current.show({ severity: 'warn', detail: res.data.massage });
                    }
                }
            })
            .catch((res) => {
                console.log(res);

                SpinnerLoading(false);

                toast.current.show({ severity: 'warn', detail: 'Error connect to services' });
            });
    };

    return (
        <>
            <Toast ref={toast} />
            <section style={{
                backgroundImage: 'url(https://api-gateway.sampangkab.go.id/be-kominfo/sampanganimation/api/getimage/L2Fzc2V0cy91cGxvYWQvaW1hZ2VzL2JhY2tncm91bmQvYmdzc2QzLW1pbi5wbmc=)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                filter: 'blur(5px)',
                height: '100%'
            }}></section>
            <section class="align-items-center d-flex h-100"
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '100%',
                    background: 'transparent'
                }}>
                <div class="container-fluid">
                    <div className="row justify-content-center mb-3">
                        <img height="100"
                            src="/assets/upload/images/template_image/kominfo.png"
                            alt="logo" />
                    </div>
                    <h5 className="text-center mb-4">DINAS KOMINFO</h5>
                    <div class="row justify-content-center align-items-center d-flex  text-center">
                        <div class="col-12 col-md-4 col-lg-3">
                            <div class="card shadow border-10" style={{ height: '250px' }}>
                                <div class="card-body"
                                    style={{
                                        width: '100%',
                                        position: 'absolute',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                    }}>
                                    <form class="m-4" onSubmit={handleSubmit}>
                                        <div class="form-group">
                                            <input type="text"
                                                name="username"
                                                value={formData.username}
                                                onChange={handleChange}
                                                class="form-control form-control-lg" placeholder="Username" />
                                        </div>
                                        <div class="form-group position-relative">
                                            <input type={passtype}
                                                name="password"
                                                value={formData.password}
                                                onChange={handleChange}
                                                class="form-control form-control-lg" placeholder="Password" />
                                            <div className="position-absolute"
                                                style={{
                                                    right: '0',
                                                    position: 'absolute',
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                    marginRight: '10px',
                                                }}>
                                                <a href="javascript:void(0)" onClick={showPassord}><i className={`fas ${(hide) ? 'fa-eye-slash' : 'fa-eye'}`}></i></a>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <button type="submit" class="btn btn-md btn-block text-white" style={{ background: 'linear-gradient(135deg,#04a,#05c,#04a,#04a,#002461)' }}>
                                                Register
                                            </button>
                                        </div>
                                        <div class="d-flex align-items-center justify-content-center">
                                            <span class="txt1">Sudah punya akun?<Link class="text-primary fw-bold ms-2" to="/login"> Login</Link></span>
                                        </div>
                                    </form>
                                </div>
                                <p className="fixed-bottom text-white">{new Date().getFullYear()} &copy; Dinas Kominfo Sampang.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Guest(LoginPage);
